export enum JobStatus {
  InProgress = 'in_progress',
  Completed = 'completed',
  Archived = 'archived'
}

export function getJobStatusLabel(status: JobStatus): string {
  switch (status) {
    case JobStatus.InProgress:
      return 'In Progress';
    case JobStatus.Completed:
      return 'Completed';
    case JobStatus.Archived:
      return 'Archived';
    default:
      return 'Unknown';
  }
}

export function getJobStatusColor(status: JobStatus): string {
  switch (status) {
    case JobStatus.InProgress:
      return '#039855';
    case JobStatus.Completed:
      return '#4E76FF';
    case JobStatus.Archived:
      return '#929292';
    default:
      return '#929292';
  }
}

export function getJobStatusOptions(): {
  value: JobStatus;
  label: string;
  index: number;
}[] {
  return [
    {
      value: JobStatus.InProgress,
      label: getJobStatusLabel(JobStatus.InProgress),
      index: 0
    },
    {
      value: JobStatus.Completed,
      label: getJobStatusLabel(JobStatus.Completed),
      index: 1
    },
    {
      value: JobStatus.Archived,
      label: getJobStatusLabel(JobStatus.Archived),
      index: 2
    }
  ];
}

export function getJobStatusIndex(status: JobStatus): number {
  switch (status) {
    case JobStatus.InProgress:
      return 0;
    case JobStatus.Completed:
      return 1;
    case JobStatus.Archived:
      return 2;
    default:
      return -1;
  }
}
